export default function UnauthorizedPage() {
  return <div className="card border-0 shadow-sm"><div className="card-body text-center py-5">
    <i className="bi bi-shield-exclamation text-danger" style={{fontSize:42}}></i>
    <h5 className="fw-bold mt-3">Access Denied</h5>
    <p className="text-muted small">You do not have permission to open this module. Ask admin to update your role permissions.</p>
  </div></div>;
}
